{
  "CommonAdminAllTelServer": "[Todos os servidores de telefonia].",
  "CommonAdminAnyPartition": "[Qualquer partição]",
  "CommonAdminAnyDevices": "[Qualquer dispositivo]",
  "CommonAdminAnyAgents": "[Qualquer agente ACD]",
  "CommonAdminAnyAgentForDevice": "[Qualquer dispositivo de configuração].",
  "CommonAdminAnyDeviceForAgent": "[Qualquer com agente ACD definido]",
  "CommonAdminUnknownOrDeleted": "[Desconhecido ou Suprimido]",
  "NAME": "CommonAdmin"
}